export default __webpack_public_path__ + "static/media/kycLevel3Panel.4cecb205.svg";